import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import toHtml from 'html-react-parser'
import * as ticketService from '../../services/ticket.services';
import Breadcrums from '../../common/breadcrumbs';
import Loader from '../../common/loader'
import { formateDate, showStatus } from '../../../../utils/commonfunction';


const TicketView = (props) => {
    const navigate = useNavigate()
    const params = useParams()
    const [showdefault, setShowDefault] = useState({})
    const breadcrumbs = [{ title: "Dashboard", url: "/admin/dashboard" }, { title: "Tickets", url: "/admin/event-management/tickets/list/1" }, { title: "View", url: "" },]


    useEffect(() => {
        ticketService.Details(params.id).then(response => {
            setShowDefault(response && response.data ? response.data : [])
        }).catch(error => {
            console.log("error=====>", error)
        })
    }, [params.id])


    return (
        <>
            <Breadcrums data={breadcrumbs} />
            <div className="row row-sm">
                <div className="col-lg-12 col-md-12 animation_fade">
                    <div className="card custom-card">
                        <div className="card-body">
                            <div>
                                <h6 className="main-content-label mb-3">View Tickets</h6>
                            </div>
                            {showdefault && Object.keys(showdefault).length > 0 ? <div className='row'>
                                <div className="col-lg-12 form-group">
                                    <table id="simple-table" className="table  table-bordered table-hover">
                                        <tbody>
                                            <tr>
                                                <th>Title</th>
                                                <td>{showdefault && showdefault.title ? showdefault.title : "N/A"}</td>
                                            </tr>
                                            <tr>
                                                <th>Type</th>
                                                <td>{showdefault && showdefault.type ? showdefault.type : "N/A"}</td>
                                            </tr>
                                            <tr>
                                                <th>Price</th>
                                                <td>{showdefault && showdefault.price ? showdefault.price : "N/A"}</td>
                                            </tr>
                                            <tr>
                                                <th>Persons</th>
                                                <td>{showdefault && showdefault.number_of_persons ? showdefault.number_of_persons : "N/A"}</td>
                                            </tr>
                                            <tr>
                                                <th>Created Date</th>
                                                <td>{showdefault && showdefault.createdAt ? formateDate(showdefault.createdAt) : "N/A"}</td>
                                            </tr>
                                            <tr>
                                                <th>Status</th>
                                                <td>{showdefault && showdefault.status === 0 ? toHtml(showStatus(showdefault.status)) : toHtml(showStatus(showdefault.status))}</td>
                                            </tr>
                                            <tr>
                                                <th>Modified Date</th>
                                                <td>{showdefault && showdefault.updatedAt ? formateDate(showdefault.updatedAt) : "N/A"}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <h6 className="main-content-label mb-3">Description</h6>
                                    <div className="">{toHtml(showdefault && showdefault.description ? showdefault.description : "N/A")}</div>
                                    <div className="mt-5">
                                        <button className="btn ripple btn-secondary" type='button' onClick={() => navigate(-1)}>
                                            <i className="ace-icon-solid ion-arrow-return-left bigger-110 mx-1"></i>
                                            Back
                                        </button>
                                    </div>
                                </div>
                            </div> : <Loader />}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default TicketView